import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { Icon } from 'fitbeat.react-native-components';
import Theme from '../../theme';

export const BackButton = ({ navigation, color = Theme.GREY_MEDIUM, size = 30 }) => (
  <TouchableOpacity
    onPress={() => {
      navigation.goBack(null);
    }}>
    <Icon
      size={size}
      color={color}
      name='ios-arrow-back'
      style={styles.backIcon}
    />
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  backIcon: {
    paddingHorizontal: 10,
  },
})
